export class ExternalSubItem {
  name: string;
  isVariable: boolean;
  key: string;
  value: string;
}
